/**
 * components/ui/LockedTab.jsx
 *
 * Shown in place of tab content when the current user lacks permission.
 * The tab is visible in the nav (visible but locked — not hidden),
 * so the user knows the feature exists and can request access.
 */

import React from 'react';

// What role is needed to unlock each tab
const ACCESS_HINT = {
  dashboard:   'Viewer',
  nifty:       'Viewer',
  performance: 'Viewer',
  options:     'Trader',
  scanner:     'Trader',
  journal:     'Trader',
  ai:          'Power Trader',
};

export default function LockedTab({ tabId }) {
  const needed = ACCESS_HINT[tabId] || 'a higher access tier';

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      gap: 16,
      color: 'var(--ink-3)',
      fontFamily: 'var(--font-ui)',
    }}>
      <div style={{
        width: 56, height: 56,
        borderRadius: '50%',
        background: 'var(--surface-2)',
        border: '0.5px solid var(--hair)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: 22,
      }}>
        🔒
      </div>

      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: 'var(--ink)', marginBottom: 6 }}>
          Access Restricted
        </div>
        <div style={{ fontSize: 12, color: 'var(--ink-3)', lineHeight: 1.7, maxWidth: 320 }}>
          This section requires <strong style={{ color: 'var(--ink-2)' }}>{needed}</strong> access
          or above. Contact your administrator to request an upgrade.
        </div>
      </div>
    </div>
  );
}
